// extracted by mini-css-extract-plugin
module.exports = {"border":"ActivitySection_border__SwWio"};